const routes = [
    {
        path: '/emissor/relatorios_manifestos',
        alias: [
            '/emissor/relatorios_manifestos/index',
            '/emissor/relatorios/manifestos',
            '/emissor/relatorios/manifestos/index',
        ],
        component: () => import('../views/Listar')
    },
    {
        name: 'formularioRelatoriosManifestos',
        path: '/emissor/relatorios_manifestos/manifestos',
        component: () => import('../views/Manifestos')
    },
    {
        name: 'impressaoRelatorio',
        path: '/emissor/relatorios_manifestos/:tipo/gerar',
        component: () => import('@/shared/components/ui/Relatorio')
      },
]

export default routes